import { ActionReducerMapBuilder, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { api } from "../../api/api";
import { IBoostsState } from ".";
import { BoostType } from "./get-boosts.handler";

export interface IBuyBoostResponse {
    type: BoostType;
    count: number;
    exp: number;
    newCost: number;
};

export const buyBoost = createAsyncThunk<IBuyBoostResponse, BoostType>(
    'buyBoost',
    async (boostType: BoostType) => await api.boosts.buyBoost(boostType)
);

export const buyBoostHandler = (builder: ActionReducerMapBuilder<IBoostsState>) => {    
    builder
        .addCase(buyBoost.pending, (state: IBoostsState) => {
            state.loading = true;
            state.error = "";
        })
        .addCase(buyBoost.fulfilled, (state: IBoostsState, action: PayloadAction<IBuyBoostResponse>) => {
            state.loading = false;
            const userBoost = state.userBoosts.find(boost => boost.type === action.payload.type);

            if (userBoost)
                userBoost.count = action.payload.count;
            else {
                const newUserBoost = {
                    type: action.payload.type,
                    count: action.payload.count,
                };
                state.userBoosts.push(newUserBoost);
            }

            state.lib = state.lib.map(lib => {
                if (lib.id === action.payload.type)
                    lib.cost = action.payload.newCost;
                return lib;
            });
        })
        .addCase(buyBoost.rejected, (state: IBoostsState) => {
            state.loading = false;
            state.error = 'Unable to buy boost';
        });
};

export default buyBoostHandler;